/* eslint-disable no-empty-function */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { AxiosInstance } from "axios";
import { Result } from "../../../Shared/Protocol/protocol-result";
import { IBillProductOrderPayload, ICancelOrderPayload, IImportOrderPayload, IOrderEntity, IOrdersListPayload, IOrdersListResponse, IOrdersRegisteredOnOmieEntity, IPickingFlowResponse, IUploadOrderPayload } from "./orders.interface";
import { Environment } from "../../../Config/constants";

export class OrdersApiRemoteService {
  constructor(private service: AxiosInstance) {}

  public bill = async ({ orderId, productsIds }: IBillProductOrderPayload): Promise<Result<IOrdersListResponse>> => {
    try {
        const response = await this.service.post(`/order/${orderId}/bill-order`, {productsIds });

      return Result.ok(response.data);
    } catch (error: any) {
      return Result.fail(error?.response?.data ?? error);
    }
  };

  public list = async ({ page, searchBy, status, store, orderBy, offset, ...rest }: IOrdersListPayload): Promise<Result<IOrdersListResponse>> => {
    try {
        const params: any = {
          offset: offset ?? Number(Environment.OFFSET_REGISTERS),
          page,
          searchBy,
          status,
          store,
          ...rest
        };

        // Serializar orderBy se existir
        if (orderBy) {
          params['orderBy[field]'] = orderBy.field;
          params['orderBy[order]'] = orderBy.order;
        }

        const response = await this.service.get(`/orders`, { params });

      return Result.ok(response.data);
    } catch (error: any) {
      return Result.fail(error?.response?.data ?? error);
    }
  };

  public show = async (orderId: string): Promise<Result<IOrderEntity>> => {
    try {
        const response = await this.service.get(`/order/${orderId}`);

      return Result.ok(response.data);
    } catch (error: any) {
      return Result.fail(error?.response?.data ?? error);
    }
  };

  public showDetails = async (omieOrderId: string): Promise<Result<IOrdersRegisteredOnOmieEntity>> => {
    try {
        const response = await this.service.get(`/order/registered-on-omie/${omieOrderId}`);

      return Result.ok(response.data);
    } catch (error: any) {
      return Result.fail(error?.response?.data ?? error);
    }
  };

  public update = async ({ orderId, ...rest}: IUploadOrderPayload): Promise<Result<void>> => {
    try {
        const response = await this.service.put(`/order/${orderId}`, {...rest});

      return Result.ok(response.data);
    } catch (error: any) {
      return Result.fail(error?.response?.data ?? error);
    }
  };

  public pickingFlow = async ({ searchBy, status, store, ...rest }: Partial<IOrdersListPayload> = { store: 'B2B' }): Promise<Result<IPickingFlowResponse[]>> => {
    try {
        const response = await this.service.get(`/orders/picking-flow`, { 
          params: {
            store: store || 'B2B',
            searchBy,
            status,
            ...rest
          }
        });

      return Result.ok(response.data);
    } catch (error: any) {
      return Result.fail(error?.response?.data ?? error);
    }
  };

  public exportInPickingList = async (): Promise<Result<Blob>> => {
    try {
        const response = await this.service.post(`/export-relatories/orders/in-picking`, {}, {
          responseType: 'blob'
        });

      return Result.ok(response.data);
    } catch (error: any) {
      return Result.fail(error?.response?.data ?? error);
    }
  };

  public cancelOrder = async ({ orderId, reason }: ICancelOrderPayload): Promise<Result<void>> => {
    try {
        const response = await this.service.post(`/order/${orderId}/cancel`, { reason });

      return Result.ok(response.data);
    } catch (error: any) {
      return Result.fail(error?.response?.data ?? error);
    }
  };

  public importOrder = async ({ orderId, store }: IImportOrderPayload): Promise<Result<void>> => {
    try {
        const response = await this.service.post(`/orders/re-import/${orderId}`, { store });

      return Result.ok(response.data);
    } catch (error) {
      return Result.fail(error);
    }
  };

  
}
